const Upload = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
  >
    <path
      d="M23.85 14.0405C23.17 10.5905 20.14 8.00049 16.5 8.00049C13.61 8.00049 11.1 9.64049 9.85 12.0405C6.84 12.3605 4.5 14.9105 4.5 18.0005C4.5 21.3105 7.19 24.0005 10.5 24.0005H23.5C26.26 24.0005 28.5 21.7605 28.5 19.0005C28.5 16.3605 26.45 14.2205 23.85 14.0405ZM23.5 22.0005H10.5C8.29 22.0005 6.5 20.2105 6.5 18.0005C6.5 15.9505 8.03 14.2405 10.06 14.0305L11.13 13.9205L11.63 12.9705C12.58 11.1405 14.44 10.0005 16.5 10.0005C19.12 10.0005 21.38 11.8605 21.89 14.4305L22.19 15.9305L23.72 16.0405C25.28 16.1405 26.5 17.4505 26.5 19.0005C26.5 20.6505 25.15 22.0005 23.5 22.0005ZM12.5 17.0005H15.05V20.0005H17.95V17.0005H20.5L16.5 13.0005L12.5 17.0005Z"
      fill="#00A1ED"
    />
  </svg>
);

export default Upload;
